// extracted by mini-css-extract-plugin
export default {"wtnBoxStyles":"wtnTeamBox_wtnBoxStyles__FxZqm","wtnStyles":"wtnTeamBox_wtnStyles__pcVPT"};